import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  { q: "What does a real estate marketing agency do?", a: "A real estate marketing agency like Digi Savvy handles end-to-end demand generation for builders and developers — project branding, RERA-compliant creatives, paid ads on Meta and Google, landing pages, CRM automation, channel-partner enablement and on-ground activations — to deliver qualified buyer leads and site visits." },
  { q: "How much does real estate marketing cost in India?", a: "Retainers typically start from ₹1.5L/month for boutique projects and scale based on ad-spend and scope. We share a transparent rate card after the inventory audit so you know exactly what you're paying for media vs. creative vs. management." },
  { q: "Do you work with channel partners and brokers?", a: "Yes — we activate channel partners across Delhi, Gurugram, Faridabad, Noida, Sonipat, Naugaon, Jaipur, Lucknow, Khatu Shyam, Dholera, Himachal, Uttarakhand and even Dubai with co-branded creatives, broker dashboards, WhatsApp lead routing and incentive structures." },
  { q: "Are your creatives RERA compliant?", a: "Every project visual is reviewed against state-specific RERA guidelines — Delhi, Gurugram (GGN), Noida, UP, Haryana, Mumbai (Maharashtra) and Rajasthan — before publishing. We include the required disclaimers, project registration IDs and possession-date language so your creatives are sellable, beautiful and lawful." },
  { q: "Can you target NRI buyers?", a: "Yes — we run NRI funnels for Dubai, Singapore, London, Toronto and San Francisco. We use geo-pixels, in-language landing pages, WhatsApp Business, and time-zone-aware sales follow-up." },
  { q: "How quickly can you launch a campaign?", a: "Audit + persona + funnel build = 7–10 working days from kickoff. Ads typically go live in week 2." },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32 border-t border-white/5">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12">
        <div>
          <div className="font-mono text-xs text-[#d4ff4f] mb-3 tracking-[0.2em]">#गहराइयाँ</div>
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40 mb-4">/ Questions</div>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[0.95]">
            Frequently<br />
            asked,<br />
            <span className="italic text-[#d4ff4f]">honestly answered.</span>
          </h2>
          <p className="text-white/60 mt-6 max-w-md leading-relaxed">
            Don't see your question? Drop a line — a real human (not a chatbot) will reply within a working day.
          </p>
        </div>
        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const active = open === i;
            return (
              <div
                key={i}
                data-testid={`faq-item-${i}`}
                className={`rounded-2xl border transition-all ${active ? "border-[#d4ff4f]/40 bg-[#d4ff4f]/[0.04]" : "border-white/10 bg-white/[0.02]"}`}
              >
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(active ? -1 : i)}
                  className="w-full px-5 py-5 flex items-center justify-between gap-4 text-left"
                >
                  <span className="font-display text-base sm:text-lg tracking-tight">{f.q}</span>
                  <span className={`w-9 h-9 shrink-0 rounded-full border ${active ? "border-[#d4ff4f] bg-[#d4ff4f] text-black" : "border-white/20"} flex items-center justify-center transition`}>
                    {active ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                <div className={`grid transition-all duration-500 ${active ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm text-white/70 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
